/**
 * Single source of truth for site identity used by SSR head metadata and JSON-LD.
 *
 * Every schema.org node that describes the organisation or the website must
 * reuse ORG_ID / WEBSITE_ID instead of re-declaring the entity. Two nodes that
 * share an @id but carry different properties make the graph contradictory,
 * which is why the per-page Organization/WebSite components were removed.
 */
export const SITE_URL = "https://www.aievolutionpolska.pl";

export const ORG_ID = `${SITE_URL}/#organization`;
export const WEBSITE_ID = `${SITE_URL}/#website`;

/** Square brand logo served from `public/`. Google requires a reachable URL. */
export const LOGO_URL = `${SITE_URL}/logo.webp`;
export const LOGO_WIDTH = 200;
export const LOGO_HEIGHT = 200;

export const CONTACT_EMAIL = "kontakt@aievolutionpolska.pl";

/**
 * Profiles the site actually links to (see `src/components/Footer.tsx`).
 * `sameAs` entries must resolve - dead profile URLs weaken entity matching.
 */
export const SAME_AS = [
  "https://www.facebook.com/groups/1322215268929827",
  "https://www.instagram.com/aievolutionpolska/",
  "https://www.youtube.com/@AIEvolutionPolska",
  "https://x.com/AIEvolutionPL",
  "https://www.tiktok.com/@aievolutionpolska",
  "https://www.linkedin.com/company/106372096",
  "https://discord.gg/yDFCUxDCzE",
];

/** Reference to the organisation node for `publisher` / `provider` slots. */
export const ORG_REF = { "@id": ORG_ID };
